import { render } from "./BannerLandingPage.vue?vue&type=template&id=38a3c89e&scoped=true"
import script from "./BannerLandingPage.vue?vue&type=script&lang=js"
export * from "./BannerLandingPage.vue?vue&type=script&lang=js"

import "./BannerLandingPage.vue?vue&type=style&index=0&id=38a3c89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a3c89e"]])

export default __exports__